/* eslint jsx-a11y/label-has-associated-control: 0 */
/* eslint jsx-a11y/label-has-for: 0 */
import React from 'react';
import PropTypes from 'prop-types';

class DropdownMultiItemCheckboxComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const { handleChange, assoc } = this.props;
    handleChange(assoc, e.target.checked);
  }

  render() {
    const { assoc } = this.props;
    return (
      <li>
        <label>
          <input
            type="checkbox"
            id="check"
            checked={assoc.Checked}
            value={assoc.ID}
            onChange={this.handleChange}
          />
          {assoc.Name}
        </label>
      </li>
    );
  }
}

DropdownMultiItemCheckboxComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  assoc: PropTypes.shape({
    Checked: PropTypes.bool.isRequired,
    ID: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  }).isRequired,
};

DropdownMultiItemCheckboxComponent.displayName = 'DropdownMultiItemCheckboxComponent';

export default DropdownMultiItemCheckboxComponent;
